import React from 'react';

import styles from './userReferralsShowPageStyles.scss';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Link from '@buyside/components/presentation/Link/link';
import ProgressBar from '@buyside/components/presentation/ProgressBar/progressBar';
import SocialShare from '@buyside/components/presentation/SocialShare/socialShare';

import { useCurrentUserAccountUserReferralsQuery } from '@interfaces/graphql-typings';

import LoadingSpinner, {
  SIZES
} from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { inviteMembersUrl, profileUrl } from '@buyside/util/urlHelper';

const { maxRewardTokenCount } = require('buyside/util/constantsFromRails.json');

import { formatDate } from '@buyside/util/dateHelper';

const RetailUserReferralsShowPage: React.FC<{}> = () => {
  const { data, loading } = useCurrentUserAccountUserReferralsQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;
  const { allTimeReferralAwards, id, userReferrals, unregisteredReferrals } = data.currentUser;

  return (
    <>
      <div className={styles.pageTitleContainer}>
        <div className={styles.pageTitle}>Your Referrals</div>
        <div className={styles.inviteButton}>
          <Button text="Invite New Members" type={BUTTON_TYPES.PRIMARY} url={inviteMembersUrl()} />
        </div>
      </div>
      <div className={styles.awardDayBox}>
        You've earned {allTimeReferralAwards || 0} idea credit
        {allTimeReferralAwards !== 1 ? 's' : ''} from your referrals.
        <div className={styles.inviteButton}>
          <Button text="Invite New Members" type={BUTTON_TYPES.PRIMARY} url={inviteMembersUrl()} />
        </div>
      </div>
      <div>
        <p>
          You can earn one (1) idea credit for each new user you refer, up to {maxRewardTokenCount}.
          Your referred user will also get a bonus idea credit when they sign up.
        </p>
        <p>Share your unique referral link with your network:</p>
        <strong>Your referral link:</strong>
        <SocialShare id={id} />
      </div>
      {userReferrals ? (
        <div className={styles.referralContainer}>
          <h4>Your Referrals</h4>
          <table>
            <tbody>
              <tr>
                <th>Member</th>
                <th>Last Active At</th>
              </tr>
              {userReferrals.map(ref => {
                const referee = ref?.referee;

                if (!referee) return null;

                return (
                  <tr key={ref?.id}>
                    <td>
                      <Link to={profileUrl(referee.id)} className={styles.refereeLink}>
                        {referee.displayName}
                      </Link>
                      <div>
                        (
                        <Link to={`mailto:${referee.email}`} className={styles.refereeLink}>
                          {referee.email}
                        </Link>
                        )
                      </div>
                    </td>
                    <td className={styles.lastActiveDate}>{formatDate(referee.activeAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
      {userReferrals && <ProgressBar progress={userReferrals.length * 10} />}
      {unregisteredReferrals && unregisteredReferrals.length ? (
        <div className={styles.referralContainer}>
          <h4>Unregistered Referrals</h4>
          <p>
            We've accepted the following referral(s) to SumZero, but they have not completed our
            two-minute registration process. To obtain free access, ensure your referrals
            successfully finish registering for SumZero:
          </p>
          <ul>
            {unregisteredReferrals.map(app => {
              return (
                <li key={app?.id}>
                  <Link to={`mailto:${app?.email}`} className={styles.refereeLink}>
                    {app?.email}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </>
  );
};

export default RetailUserReferralsShowPage;
